import { prefixerM } from './utils'

export const ROUTE_BANDEJA = prefixerM('bandeja-plantillas')
export const ROUTE_PLANTILLA_PRESUPUESTO = prefixerM('plantilla-presupuesto')
